import { AxiosError } from 'axios';
import { ActionType } from 'typesafe-actions';
import { Enterprise } from '../auth';
import * as actions from './actions';

export enum ProjectStatus {
  IN_PROGRESS = '0',
  CLOSED = '1',
  BIDDING = '2',
  AFTER_CONSTRUCTION = '3',
}

export const projectStatusKorean = {
  '0': '공사 중',
  '1': '공사 완료',
  '2': '계획 중',
  '3': '준공 후',
} as const;

export type ProjectsAction = ActionType<typeof actions>;
export interface ProjectsState {
  projects: {
    data: Project[] | null;
    loading: boolean;
    error: AxiosError | null;
  };
  project: {
    data: Project | null;
    loading: boolean;
    error: AxiosError | null;
  };
  currentProjectId: number | null;
  currentProjectName: string | null;
}

export interface Project {
  id: number;
  name: string;
  location: string;
  detailedLocation?: string;
  status: ProjectStatus;
  startDate: string;
  endDate: string;
  owner: string;
  type?: string;
  area?: number;
  architect: string;
  description: string;
  config: any;
  file: SharedFile[];
  enterprise?: Enterprise;
  projectConfig: ProjectConfig;
}

export interface ProjectConfig {
  id: number;
  config: any;
}

export interface SharedFile {
  id: number;
  mimeType: string;
  name: string;
  path: string;
  uid: string;
}

export interface ProjectParams {
  enterpriseId: string;
  projectId?: string;
  file?: any;
  sharedFileId?: number;
  project?: Project;
  projectConfigId?: number;
  projectConfig?: any;
  filter?: any;
}
